import { environment } from "src/environments/environment";

export class ApiUrl {
  private static get baseUrl(): string {
    return environment.baseUrl;
  }

  static get basrUrl(): string {
    return this.baseUrl;
  }

  static get login(): string {
    return this.baseUrl + 'auth/login';
  }

  static get signup(): string {
    return this.baseUrl + 'auth/signup';
  }

  static get loginWithGoogle(): string {
    return this.baseUrl + 'auth/google';
  }

  static get loginWithApple(): string {
    return this.baseUrl + 'auth/apple';
  }

  static get activate(): string {
    return this.baseUrl + 'auth/activate';
  }

  static get forgot_password(): string {
    return this.baseUrl + 'auth/forgot_password';
  }
  static get return_forgot_password(): string {
    return this.baseUrl + 'auth/return_forgot_password';
  }
  static get change_password(): string {
    return this.baseUrl + 'auth/change_password';
  }

  static get logout(): string {
    return this.baseUrl + 'auth/logout';
  }

  static get check_reg_type(): string {
    return this.baseUrl + 'auth/check_reg_type';
  }

  static get userProfile(): string {
    return this.baseUrl + 'profile';
  }

  static get setAddress(): string {
    return this.baseUrl + 'profile/address';
  }

  static get setWeight(): string {
    return this.baseUrl + 'biometrics/weight';
  }

  static get setImc(): string {
    return this.baseUrl + 'biometrics/imc';
  }

  static get setProfilePicture(): string {
    return this.baseUrl + 'biometrics/profile_picture';
  }

  static get setPicture(): string {
    return this.baseUrl + 'biometrics/photo';
  }

  static get setBlood(): string {
    return this.baseUrl + 'biometrics/blood';
  }

  static get biometrics(): string {
    return this.baseUrl + 'biometrics';
  }

  static get sports(): string {
    return this.baseUrl + 'sports';
  }

  static get blogs(): string {
    return this.baseUrl + 'articles';
  }

  static get meals(): string {
    return this.baseUrl + 'public/meals';
  }

  static get selectedMeals(): string {
    return this.baseUrl + 'public/meals/selected';
  }

  static get publicExperts(): string {
    return this.baseUrl + 'public/experts';
  }

  static get webview(): string {
    return this.baseUrl + 'public/webview';
  }

  static get publicPromotions(): string {
    return this.baseUrl + 'public/promotion';
  }

  static get userExpert(): string {
    return this.baseUrl + 'user/expert';
  }

  static get experts(): string {
    return this.baseUrl + 'experts';
  }

  static get vitamins(): string {
    return this.baseUrl + 'store/vitamins';
  }

  static get fineSupplements(): string {
    return this.baseUrl + 'store/fine_supplements';
  }

  static get healthBoostIngredients(): string {
    return this.baseUrl + 'store/health_boost_ingredients';
  }

  static get snacks(): string {
    return this.baseUrl + 'store/snacks';
  }

  static get userOrders(): string {
    return this.baseUrl + 'orders/show';
  }

  static get userOrder(): string {
    return this.baseUrl + 'orders';
  }

  static get userCreditCards(): string {
    return this.baseUrl + 'credit_cards';
  }

  static get allergies(): string {
    return this.baseUrl + 'allergies';
  }

  static get mealCategories(): string {
    return this.baseUrl + 'categories';
  }

  static get tags(): string {
    return this.baseUrl + 'tags';
  } 

  static get orders(): string {
    return this.baseUrl + 'orders';
  }

  static get discount(): string {
    return this.baseUrl + 'discount';
  }

  static get shipments(): string {
    return this.baseUrl + 'shipments';
  }

  static get notifications(): string {
    return this.baseUrl + 'notifications';
  }

  static get weeklyDeliveriesCount(): string {
    return this.baseUrl + 'public/orders/deliveries-per-week';
  }
}
